export const SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS = 'SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS';
export const SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_FAILED = 'SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_FAILED';
